import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const clientId = "683384738133-ct55hc4h317b1h9to83kthp71g6qqeaf.apps.googleusercontent.com";

const isDev = process.env.NODE_ENV === "development";

const app = (

    <App />

);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(isDev ? <React.StrictMode>{app}</React.StrictMode> : app);

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
